import EditableCell from "@components/EditableCell"
import { TableNodeProperties } from "@features/builder/graph/types"
import { NodeFormValues } from "@features/builder/NodeDrawer/NodeForm"
import { getHeaders } from "@features/builder/NodeDrawer/NodeForm/NodeTableAccordion/getHeaders"
import { getRows } from "@features/builder/NodeDrawer/NodeForm/NodeTableAccordion/getRows"

import {
  FormHelperText,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"
import { CUSTOM_ERROR_ATTRIBUTE } from "@utils/form"
import { useFormContext } from "react-hook-form"

type TableNodeTableProps = {
  onPropertiesUpdate?: (properties: TableNodeProperties) => void
}

const TableNodeTable = (props: TableNodeTableProps) => {
  const form = useFormContext<NodeFormValues>()
  const properties = form.getValues("attributeProperties")

  const headers = getHeaders(properties, form, props.onPropertiesUpdate)
  const rows = getRows(properties, headers, form, props.onPropertiesUpdate)

  const columnsRelatedError = form.formState.errors.attributeProperties?.columns?.message
  const rowsRelatedError = form.formState.errors.attributeProperties?.index?.message

  const tableErrors = [columnsRelatedError, rowsRelatedError]

  return (
    <>
      <TableContainer>
        <Table size="small" padding="none">
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <EditableCell
                  {...header}
                  key={header.key}
                  control={form.control}
                  // @ts-ignore "string" is too generic to fit specific field names
                  name={header.name}
                  sx={{ px: ".15em" }}
                />
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {headers.map(({ idx }) => (
                  <EditableCell
                    key={idx}
                    {...row[idx]}
                    // @ts-ignore "string" is too generic to fit specific field names
                    name={row[idx].name}
                    control={form.control}
                  />
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {tableErrors.filter(Boolean).map((error, index) => (
        <FormHelperText
          key={`${error}-${index}`}
          error
          {...{ [CUSTOM_ERROR_ATTRIBUTE]: Boolean(error) }}
        >
          - {error}
        </FormHelperText>
      ))}
    </>
  )
}

export default TableNodeTable
